import React from 'react';
import { translate } from '../../../Services/translation';
import PriceModel from '../../../Types/PriceModel';
import { LinkModel } from '../../../Types/LinkModel';
import { OrderRow } from '../../../Types/OrderRow';
import StockStatus from '../../StockStatus/StockStatus';

interface OrderDetailProduct extends OrderRow {
  imageUrl: string;
  link: LinkModel;
  priceInfo: PriceModel;
  unit: string;
}

const UnitPrice = ({
  price,
  unit,
}: {
  price: PriceModel;
  unit: string;
}) => {
  return (
    <span className="text-md text-gray-500">
      {price.formattedCampaignPrice ? (
        <span className="text-campaign">
          {price.formattedCampaignPrice}
        </span>
      ) : (
        price.formattedPrice
      )}{' '}
      / {unit}{' '}
      {price.formattedCampaignPrice ? (
        <span className="ml-2 line-through">{price.formattedPrice}</span>
      ) : null}
    </span>
  );
};

const OrderDetailProductCard = ({
  product,
}: {
  product: OrderDetailProduct;
}) => {
  console.log(product);

  return (
    <div className="flex flex-col px-6">
      <div className="flex gap-4 border-gray-100 py-5 text-md">
        <a
          href={product.link.href}
          className="h-fit overflow-hidden rounded"
        >
          <img
            src={product.imageUrl}
            className="h-20 w-14 object-cover md:h-32 md:w-24"
          />
        </a>
        <div className="flex flex-1 flex-col gap-1.5">
          <div className="flex flex-col gap-2">
            <span className="text-md text-gray-500">
              {product.productType}: {product.articleNumber}
            </span>
            <a href={product.link.href}>
              <h4>{product.name}</h4>
            </a>
          </div>
          <div className="flex flex-col gap-1.5">
            {product.extraInfo &&
              product.extraInfo.items.map((item) => (
                <span
                  key={'order-detail' + item.key}
                  className="text-md text-gray-500"
                >
                  {item.key}: {item.value}
                </span>
              ))}
            {product.previewUrl && (
              <span>
                <a
                  className="text-md text-gray-500 underline decoration-gray-500"
                  href={product.previewUrl}
                  target="_blank"
                  rel="noreferrer"
                >
                  {translate('order-row.see-preview')}
                </a>
              </span>
            )}
            <UnitPrice price={product.priceInfo} unit={product.unit} />
            {product.stockStatus && (
              <StockStatus {...product.stockStatus} className="!mb-0" />
            )}
          </div>
          <div className="flex items-center justify-between">
            <span className="text-lg font-normal">
              {translate('product.quantity')}: {product.quantityString}{' '}
              {product.priceInfo?.price?.unitOfMeasurementTitle}
            </span>
            <span className="text-lg font-normal">
              {translate('product.total')}: {product.totalPrice}
            </span>
          </div>
          {product.note && (
            <span className="text-lg font-light text-gray-500">
              {product.note}
            </span>
          )}
        </div>
      </div>
      <hr className="h-px w-full bg-gray-100" />
    </div>
  );
};

export default OrderDetailProductCard;
